import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "super-return"
}
const _hoisted_2 = { class: "super-return-text" }
const _hoisted_3 = ["disabled"]

import { computed, onUnmounted, ref, watch } from 'vue'
import { useRouter } from 'vue-router'
import { alertError } from '@/services/appApi'
import { authStore } from '@/stores/auth'


export default /*@__PURE__*/_defineComponent({
  __name: 'SuperReturnBar',
  setup(__props) {

const router = useRouter()
const leaving = ref(false)
const visible = computed(() => authStore.impersonating.value)
const label = computed(() => {
  const user = authStore.state.user
  if (!user) return '다른'
  if (user.appRole === 'CAREGIVER') return user.name || '요양보호사'
  return user.centerName || user.name || '센터'
})

watch(
  visible,
  (on) => {
    document.body.classList.toggle('has-super-return', on)
  },
  { immediate: true }
)
onUnmounted(() => {
  document.body.classList.remove('has-super-return')
})

const leave = async () => {
  if (leaving.value) return
  leaving.value = true
  try {
    await authStore.exitSuper()
    await router.replace('/owner')
  } catch (e) {
    await alertError('슈퍼 계정', e)
  } finally {
    leaving.value = false
  }
}

return (_ctx: any,_cache: any) => {
  return (visible.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("p", _hoisted_2, _toDisplayString(label.value) + " 계정으로 보는 중입니다.", 1),
        _createElementVNode("button", {
          type: "button",
          class: "super-return-btn",
          disabled: leaving.value,
          onClick: leave
        }, " 슈퍼 계정으로 나가기 ", 8, _hoisted_3)
      ]))
    : _createCommentVNode("", true)
}
}

})